export default "__VITE_ASSET__57d128d8__"